module.exports = {"weekdays":["sunday","monday","tuesday","wednesday","thursday","friday","saturday"],"defaultWorkStart":{"hour":9,"minute":0},"defaultWorkEnd":{"hour":18,"minute":0},"notificationsPreferences":["All","ImportantOnly","None"],"nbDaysToShowInArchivePage":10,"limitPaginationArchive":20,"delayBeforePatch":{"default":1000}}


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/constants/constants.json
// module id = 627
// module chunks = 0